// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7021cadc","498":"5856f85b","703":"ea6d9a53","787":"2db5572a"}[chunkId] + ".chunk.js";
};